<template src="./index.html"></template>
<script>
import { quillEditor } from "vue-quill-editor";
import config from "../../../../configHttp.js";
export default {
  name: "",
  components: {
    quillEditor,
  },
  props: {
    options:{
      type:Array,
      default:[]
    },
    seezcdiag: {
      type: Boolean,
      default: false,
    },
    formlist: {
      type: Array,
      default: [],
    },

    //form表单数据
    formdata: {
      type: Object,
      default: {},
    },
    //原文件链接、文本框数据
    fbkyuwduixi: {
      type: Object,
      default: {
        originalLink: "",
        content: "",
      },
    },
    //政策
    zcData: {
      type: Array,
      default: [],
    },
    //文件
    fileData: {
      type: Array,
      default: [],
    },
  },
  data: function () {
    return {
      plData: [],
      url:"",
      hidebox: false,
      editorOption: {
        modules: {
          toolbar: null,
        },
      },
    };
  },
  watch:{
     seezcdiag: function (indexVal, oldVal) {
        if (indexVal) {
          this.$nextTick(() => {
            if(this.fileData.length > 0 ){
              this.url = this.fileData[0].fileUrl
            }else{
              this.url = ''
            }
          });
        }
      }
  },
  created() {},
  methods: {
    onEditorFocus(event) {
      event.enable(false);
    },
    ywjxz(url) {
      window.open(url);
    },
    wenjianxiaz(url, fileName) {
      this.url = this.$winURl +  url
    },
    //切换标题内容
    changeContent(item){
      this.$emit("changeContent", item);
    },
    fordelete() {
      this.$showConfirm({
        message: "确认删除该评论?",
      }).then((res) => {
        if (res == "confirm") {
        }
      });
    },
    closediag() {
      this.$emit("closediag", false);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
